<template>
  <tr
    :class="rowClasses"
    data-testid="entries-table-row"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <EntriesTableCell
      v-for="header in headers"
      :key="header"
      :entry="entry"
      :header="header"
    />
  </tr>
</template>

<script setup lang="ts">
import type { TableEntry } from '@app/types'

import { computed } from 'vue'

import EntriesTableCell from './entries-table-cell.vue'

interface Props {
  entry: TableEntry
  headers: string[]
  hoveredAttributes: string[]
}

const props = defineProps<Props>()

const emit =
  defineEmits<{
    (_e: 'enter-row', _attributes: string[]): void
    (_e: 'leave-row', _attributes: string[]): void
  }>()

const shouldAppearHovered = computed(() => {
  return props.hoveredAttributes && props.hoveredAttributes.length > 0
    ? props.hoveredAttributes.every(
        (attribute) => props.entry.attributes?.[attribute]
      )
    : false
})

const rowClasses = computed(() => ({
  'entries-table-row--hovered': shouldAppearHovered.value,
}))

function handleMouseEnter() {
  if (props.entry.attributes) {
    emit('enter-row', Object.keys(props.entry.attributes))
  }
}

function handleMouseLeave() {
  if (props.entry.attributes) {
    emit('leave-row', Object.keys(props.entry.attributes))
  }
}
</script>

<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.entries-table-row {
  &--hovered {
    td {
      @include background-color('neutral', 'subtle-1');
    }
  }
}
</style>
